import { put, get } from 'core_main/request';
import { UpdateSatisfactionResponseOptions } from './types';
import {
  validateUpdateSatisfactionResponseParams,
  makeSatisfactionResponseEndpoint,
  makeTranslatedSatisfactionFormEndpoint,
} from './helpers';

export const updateSatisfactionResponse = (
  satisfactionResponseId: string,
  options: UpdateSatisfactionResponseOptions,
  lang?: string,
) => {
  const validateUpdateSatisfactionResponseError =
    validateUpdateSatisfactionResponseParams(satisfactionResponseId, options);

  if (validateUpdateSatisfactionResponseError) {
    return Promise.reject(validateUpdateSatisfactionResponseError);
  }

  return put(makeSatisfactionResponseEndpoint(satisfactionResponseId, lang), {
    body: JSON.stringify(options),
  });
};

export const getTranslatedSatisfactionForm = (
  satisfactionId: string,
  lang?: string,
) => {
  if (!satisfactionId) {
    return Promise.reject(new Error('Satisfaction form ID is required'));
  }

  const endpoint = makeTranslatedSatisfactionFormEndpoint(satisfactionId, lang);
  return get(endpoint as any);
};
